import React from 'react';
import {connect} from 'react-redux';

import mapDispatch from '~/misc/mapDispatch';
import Button from '~/components/common/Button';
import {modalChange} from '~/modules/modal/actions';
import {toggleRouteTruckStops, toggleRouteWeightStations} from '~/modules/loads/actions';
import config from '~/config';

import css from './index.css';

class MapControls extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {toggleTruckStops, toggleWeightStations, toggledTruckStops, toggledWeightStations} = this.props;

    return (
      <div className={css.wrap}>
        {config.poi2 && <div className={css.buttonWrap}>
          <Button className ={css.buttonInject}onClick={toggleWeightStations}>
            Weight Stations <input type='checkbox' checked={toggledWeightStations} value={toggledWeightStations}/>
          </Button>
        </div>}

        {config.poi2 && <div className={css.buttonWrap}>
          <Button className ={css.buttonInject} onClick={toggleTruckStops}>
            Truckstops <input type='checkbox' checked={toggledTruckStops} value={toggledTruckStops}/>
          </Button>
        </div>}

        <div className={css.buttonWrap}>
          <Button
            className ={css.buttonInject}
            onClick={this.props.toggleMap}
            data-qa={this.props.toggled
              ? this.props.dataQa('hide-map')
              : this.props.dataQa('view-map')
            }
          >
            {this.props.toggled ? 'Hide Map' : 'View Map'}
          </Button>
        </div>
      </div>
    );
  }
}

export default connect(({loads}, {id}) => ({
  toggledTruckStops: loads.toggledTruckStops[id] || null,
  toggledWeightStations: loads.toggledWeightStations[id] || null,
}), mapDispatch({
  toggleMap: (props) => modalChange(`loadmap/${props.id}`, 'loadcard'),
  toggleTruckStops: props => toggleRouteTruckStops(props.identity),
  toggleWeightStations: props => toggleRouteWeightStations(props.identity),
}))(MapControls);



// WEBPACK FOOTER //
// ./src/components/search/results/LoadCard/MapControls/index.js